import { Button, Modal } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import sanadLogo from "../../assets/images/rating/sanad/popup-sanad-logo.png";
import happy from "../../assets/images/rating/sanad/happy-face.png";
import neutral from "../../assets/images/rating/sanad/neutral-face.png";
import unhappy from "../../assets/images/rating/sanad/unhappy-face.png";
import thankyou from "../../assets/images/rating/Thank-you.png";
import { classNames } from "primereact/utils";
import useMediaQuery from "@mui/material/useMediaQuery";
import config from "../../config";

export default function RatingComp() {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const [submitted, setSubmitted] = useState(true);

  const matches = useMediaQuery(
    `(min-width:${config.breakdowns.MOBILE_MAX_WIDTH}px)`
  );

  const ratingPoints = [
    { name: "easeOfUse", title: t("rating.easyToUse") },
    { name: "performance", title: t("rating.systemResponse") },
  ];

  const ratings = [
    { icon: happy, value: "happy" },
    { icon: neutral, value: "neutral" },
    { icon: unhappy, value: "unhappy" },
  ];

  const [rating, setRating] = useState(
    ratingPoints.reduce(
      (final, { name }) => ({ ...final, [name]: "happy" }),
      {}
    ) || {}
  );

  const updateRate = (point, rate) => {
    let temp = { ...rating };
    temp[point] = rate;
    setRating(temp);
  };

  return (
    <>
      <Button
        onClick={() => setModalOpen(true)}
        className="p-button-outlined mx-4 bottom-0 text-white border-0 fm-kufi-bold"
        style={{
          width: "10vw",
          minWidth: "fit-content",
          zIndex: 1000,
          height: "6vh",
          position: "fixed",
          backgroundColor: "#a11e18",
          borderRadius: "10px 10px 0 0 ",
          left: "0px",
        }}
      >
        {t("common.rate")}
      </Button>

      {modalOpen && (
        <Modal
          closable={true}
          centered
          visible={modalOpen}
          footer={null}
          onCancel={() => {
            setModalOpen(false);
            setSubmitted(false);
          }}
          className="view-menu container"
          width={matches ? "40vw" : "1000vw"}
          style={{ borderRadius: "20px", textAlign: "right" }}
        >
          {submitted ? (
            <div className="d-flex flex-column justify-content-center align-items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                fill="currentColor"
                class="bi bi-check2-circle text-success"
                viewBox="0 0 16 16"
              >
                <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
                <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
              </svg>
              <p className="fm-kufi-bold m-0 text-lg">{t("common.thankYou")}</p>
              <p className="fm-kufi-regular m-0">{t("common.rateProcessCompleted")}</p>
              {/* <img
                src={thankyou}
                className="mx-2 w-25"
                width="80vw"
                alt="logo"
              /> */}
            </div>
          ) : (
            <>
              <img
                src={sanadLogo}
                className="mx-2 text-end"
                width="80"
                alt="logo"
              />

              <h6 className="fm-kufi-regular text-center mb-4 mt-2">
                {t("common.rate")}
              </h6>

              <table className="text-end bg-light w-100 my-5">
                <tbody>
                  {ratingPoints.map(({ title, name }) => (
                    <tr>
                      <td className="p-2">
                        <h6
                          className="fm-kufi-regular text-danger"
                          style={{ fontSize: matches ? "16px" : "14px" }}
                        >
                          {title}
                        </h6>
                      </td>

                      {ratings.map(({ icon, value }) => (
                        <td className="p-2 text-center">
                          <img
                            src={icon}
                            className={classNames({
                              "text-left cursor-pointer": true,
                              selected: value === rating[name],
                            })}
                            style={{ backgroundColor: "#808081" }}
                            width={matches ? "30" : "100%"}
                            alt="logo"
                            onClick={() => updateRate(name, value)}
                          />
                          {/* {value === rating[name] && (
                            <hr className="w-100 text-danger p-0 m-0" />
                          )} */}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>

              <textarea
                className={classNames({
                  "w-100 fm-kufi-regular notes-text-area my-3 p-2": true,
                  "text-xs": !matches,
                })}
                placeholder={t("rating.anyNotes")}
                rows={3}
              />

              <div className="d-flex justify-content-center">
                <button
                  style={{
                    borderRadius: "5px",
                    backgroundColor: "#dd0f20",
                    color: "white",
                    paddingLeft: "50px",
                    paddingRight: "50px",
                  }}
                  className="btn btn-regular fm-kufi-regular tex-sm"
                  onClick={() => setSubmitted(true)}
                >
                  {t("common.send")}
                </button>
              </div>
            </>
          )}
        </Modal>
      )}
    </>
  );
}
